import React, { useContext, useState } from 'react'
import { createPortal } from 'react-dom'

import { Button as SlabButton, useBreakpoint } from 'slab'

import { MultistepFiltersContext } from './context'

interface ButtonProps
  extends Omit<React.ComponentProps<typeof SlabButton>, 'size' | 'variant'> {
  children: React.ReactNode;
}

export function Button ({ children, onClick, ...props }: ButtonProps) {
  const { buttonSlot, setActiveFilter, setEditing } = useContext(MultistepFiltersContext)
  const [waiting, setWaiting] = useState(false)
  const { breakpointIsAtLeast } = useBreakpoint()

  const button = (
    <SlabButton
      {...props}
      disabled={props.disabled || waiting}
      onClick={async (event) => {
        setActiveFilter(null)
        setWaiting(true)
        await onClick?.(event)
        setWaiting(false)
        setEditing(false)
      }}
      size='large'
      variant='primary'
      width='full'
    >
      {children}
    </SlabButton>
  )

  // For viewports at or above the `xs` breakpoint, the button is rendered in
  // line with the filters bar.
  if (breakpointIsAtLeast('xs')) {
    return (
      <div className='p-2 w-36 flex items-center'>
        {button}
      </div>
    )
  }

  // Below the `xs` breakpoint, the button is portalled into the bottom
  // sheet with the filter content.
  return buttonSlot ? createPortal(button, buttonSlot) : null
}

Button.displayName = 'MultistepFilters.Button'
